query GetBeeToken($input: String!) {
    beeToken(product: $input)
}
